import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from '../_services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class OnlineBookingEntryGuard implements CanActivate {
  constructor(
    private readonly auth: AuthenticationService,
    private readonly router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean | UrlTree {
    if (this.auth.isLoggedIn()) {
      return true;
    }

    const customer = `${route.paramMap.get('customer') || ''}`.trim();
    const site = `${route.paramMap.get('site') || ''}`.trim();

    if (customer && site) {
      return this.router.createUrlTree(['/book', customer, site]);
    }

    return this.router.createUrlTree(['']);
  }
}
